module.exports = __webpack_public_path__ + "052aee16b067a81dcba378c56b74eff3.jpg";